module.exports = __webpack_public_path__ + "static/media/WhatsApp_Logo.949247cc.png";